import React from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

import { Theme } from '../../../styles/theme';

export interface ThemeProviderProps {
  theme: Theme;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({
  theme,
  children,
}) => {
  const Provider: any = StyledThemeProvider;
  return <Provider theme={theme}>{children}</Provider>;
};
